import React, { useCallback, useEffect } from "react";
import { Grid, IconButton, Tooltip } from "@material-ui/core";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Edit } from "@material-ui/icons";
import {
  CustomButton,
  CustomIconButton,
  PageWrapper,
  Simplelink,
} from "../../assets/styled";
import Table from "../../components/Table";
import * as thunks from "../../store/thunks";

function Blogs() {
  const dispatch = useDispatch();
  const getBlogsService = useCallback(
    () => dispatch(thunks.getBlogs()),
    [dispatch],
  );

  const blogsData = useSelector((state1) => state1.blogs);

  useEffect(() => {
    getBlogsService();
  }, [getBlogsService]);

  const columns = [
    {
      name: "id",
      text: "ID",
      filterable: true,
      align: "left",
      sortable: true,
      type: "text",
    },
    {
      name: "is_removed",
      text: "Statü",
      filterable: true,
      align: "left",
      sortable: true,
      type: "text",
      customBody: (value) => <span>{value ? "Pasif" : "Yayında"}</span>,
    },
    {
      name: "updatedAt",
      text: "Güncelleme Tarihi",
      filterable: true,
      align: "left",
      sortable: true,
      type: "text",
      customBody: (value) => <span>{moment(value).format("DD.MM.YYYY")}</span>,
    },
    {
      name: "title",
      text: "Blog Başlığı",
      filterable: true,
      align: "left",
      type: "text",
    },
    {
      name: "view_count",
      text: "Görüntülenme",
      filterable: true,
      align: "left",
      type: "text",
    },
    {
      name: "Action",
      text: "İşlemler", // Başlığı projenin geneline uygun Türkçeleştirdik
      filterable: false,
      editable: false,
      align: "center", // İkonu ortalamak daha dengeli durur
      sortable: false,
      type: "action",
      disableSetting: true,
      customBody: (value, columnName, index, row) => (
        <div
          key={`blog-act-${row.id}`}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={(e) => e.stopPropagation()} // Satır tıklamasını durdurur
        >
          <Simplelink to={`/Blog/${row.id}`}>
            <Tooltip title="Bloğu Düzenle" placement="top" arrow>
              <IconButton
                style={{
                  backgroundColor: "rgba(0, 242, 255, 0.05)", // Çok hafif turkuaz arka plan
                  border: "1px solid rgba(0, 242, 255, 0.1)",
                  borderRadius: "10px",
                  padding: "8px",
                  transition: "all 0.3s ease",
                }}
                // Hover efekti CSS yerine inline denenebilir veya styled-component kullanılabilir
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(0, 242, 255, 0.15)";
                  e.currentTarget.style.borderColor = "#00F2FF";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(0, 242, 255, 0.05)";
                  e.currentTarget.style.borderColor = "rgba(0, 242, 255, 0.1)";
                }}
              >
                <Edit style={{ color: "#00F2FF", fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          </Simplelink>
        </div>
      ),
    },
  ];

  return (
    <PageWrapper>
      <Grid container spacing="3">
        <Grid item lg={12} xs={12}>
          <h1 style={{ color: "white" }}>
            Blogları Görüntüle, düzenle ve yarat
          </h1>
        </Grid>
        <Grid item lg={12} xs={12}>
          <Simplelink to="/NewBlog">
            <CustomButton component="label">Yeni Blog</CustomButton>
          </Simplelink>
        </Grid>
        <Grid item lg={12} xs={12}>
          <Table
            data={blogsData || []}
            columns={columns || []}
            id="blogsTable"
            options={{
              selectableRows: "none",
              header: {
                visible: true,
                columnSetting: false,
              },
              filter: {
                show: true,
                filters: [],
                // onChange: (state, value, text, type) => console.log(state, value, text, type),
                // drawerChange: () => setState(prevstate => ({ filterDrawer: !prevstate.filterDrawer })),
              },
              pagination: {
                active: true,
                perPage: 20,
              },
            }}
          />
        </Grid>
      </Grid>
    </PageWrapper>
  );
}

export default Blogs;
